module.exports = __webpack_public_path__ + "static/img/9.c340694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/9.png
// module id = hqMA
// module chunks = 0